import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { getOrganizations } from '../../api/organizationApi';
import { LinkTile } from "../../shared/linkTile";
import { Organization } from "../../api/models/organization";
import { ErrorHeader } from "../../shared/errorHeader";
import { useApi } from "../../hooks/useApi";
import { LoginHeader } from "../../shared/loginHeader";
import { InfoBar } from "../../shared/infoBar";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { useApiCallWithAuth } from "../../hooks/useApiCallWithAuth";
import { getIsSuperAdmin } from "../../api/userApi";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

export function OrganizationListPage() {
    const [organizations, setOrganizations] = useState<Organization[]>([]);
    const [errorMessage, setErrorMessage] = useState<string>('');
    const [isSuperAdmin, setIsSuperAdmin] = useState<boolean>(false);

    const getOrgsApi = useApi(getOrganizations);
    const { user, isAuthenticated} = useAuth0();

        const navigate = useNavigate();

    const publicOrgs = organizations.filter(x => x.isPublic);
    const privateOrgs = organizations.filter(x => !x.isPublic);

    const getUserRequest = useApiCallWithAuth(getIsSuperAdmin);


       useDocumentTitle("Org List Page");

    useEffect(() => {
        initPage();
    }, []);

    useEffect(() => {
        if (getOrgsApi.data) {
            console.log(`org data`,getOrgsApi.data);
            setOrganizations(getOrgsApi.data);
        }
    }, [getOrgsApi.data]);

    useEffect(() => {
        if (getOrgsApi.error) {
            setErrorMessage(getOrgsApi.error);
        }
    }, [getOrgsApi.error]);

    function initPage(){

        getOrgsApi.request();
    }

        function adminPageHandler() {
        if (isAuthenticated && user) {
            navigate(`/orgs/new`);
        }
    }

        function renderHeader() {
            return (
                <Grid container spacing={2} justifyContent="flex-start" alignItems="center" >
                    <Grid item><h1>Organizations</h1></Grid>
                    {isAuthenticated && user && <Grid item> <Button color="primary"
                        variant="contained"
                        onClick={e => adminPageHandler()} >
                        Add
                    </Button></Grid>}
                </Grid>
            );
        }

    const mainContent = () => {

        return (
            <Box>
                 <InfoBar  />

                {renderHeader()}

                <Grid container spacing={2}>
                    {publicOrgs.map(item =>
                        <Grid item key={item.id}>
                            <LinkTile firstName={item.name}
                                key={item.id}
                                linkUrl={'/orgs/' + item.id}
                                imageUrl={item.logoLink} />
                        </Grid>
                    )}
                </Grid>
                {privateOrgs && privateOrgs.length > 0 &&
                    <Box>
                <h3>Private Organizations</h3>
                <Grid container spacing={2}>
                    {privateOrgs.map(item =>
                        <Grid item key={item.id}>
                            <LinkTile firstName={item.name}
                                key={item.id}
                                linkUrl={'/orgs/' + item.id}
                                imageUrl={item.logoLink} />
                        </Grid>
                    )}
                </Grid>
                </Box>
            }
            </Box>
        );
    }

    return (

        <Box>
            <ErrorHeader errorMessage={errorMessage} />
            {getOrgsApi.loading && <CircularProgress />}
            {organizations && mainContent()}
            {!organizations && <p>No organizations found</p>}
        </Box>
    );

}